import React, { useState } from 'react';
import './PasswordProtection.css';
import { FaLock } from 'react-icons/fa';

const PasswordProtection = ({ onAuthenticate }) => {
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [attempts, setAttempts] = useState(() => {
        const stored = localStorage.getItem('loginAttempts');
        if (stored) {
            const { count, timestamp } = JSON.parse(stored);
            if (Date.now() - timestamp < LOCKOUT_TIME) {
                return count;
            }
        }
        return 0;
    });
    const [isLocked, setIsLocked] = useState(false);
    const [lockTimer, setLockTimer] = useState(null);

    const MAX_ATTEMPTS = 3;
    const LOCKOUT_TIME = 300000; // 5 minutes in milliseconds
    const PREVIEW_PASSWORD = process.env.REACT_APP_PREVIEW_PASSWORD;

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isLocked) {
            setError('Too many attempts. Please try again later.');
            return;
        }

        setLoading(true);
        setError('');

        try {
            if (password === PREVIEW_PASSWORD) {
                localStorage.setItem('previewAccess', 'granted');
                onAuthenticate(true);
                setAttempts(0);
            } else {
                const newAttempts = attempts + 1;
                setAttempts(newAttempts);

                if (newAttempts >= MAX_ATTEMPTS) {
                    setIsLocked(true);
                    const timer = setTimeout(() => {
                        setIsLocked(false);
                        setAttempts(0);
                    }, LOCKOUT_TIME);
                    setLockTimer(timer);
                    throw new Error('Maximum attempts reached');
                }
                throw new Error('Invalid password');
            }
        } catch (error) {
            if (error.message === 'Maximum attempts reached') {
                setError(`Too many failed attempts. Please try again in 5 minutes.`);
            } else {
                setError(`Invalid preview password. ${MAX_ATTEMPTS - attempts - 1} attempts remaining.`);
                setTimeout(() => setError(''), 3000);
            }
        } finally {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        return () => {
            if (lockTimer) {
                clearTimeout(lockTimer);
            }
        };
    }, [lockTimer]);

    return (
        <div className="password-protection">
            <div className="coming-soon-background"></div>
            <div className="coming-soon-container">
                <div className="logo-section">
                    <img 
                        src="../images/fomeje-logo-2025.png" 
                        alt="Fomeje Logo" 
                        className="coming-soon-logo"
                    />
                </div>
                
                <div className="content-section">
                    <h1>Coming Soon</h1>
                    <div className="animated-dots">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                    <p className="subtitle">Enter preview password to access the site</p>
                    
                    <form onSubmit={handleSubmit} className="password-form">
                        <div className="input-group">
                            <FaLock className="input-icon" />
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Preview Password"
                                className="auth-input"
                                required
                                disabled={isLocked}
                            />
                        </div>

                        <button 
                            type="submit" 
                            className={`submit-button ${loading ? 'loading' : ''}`}
                            disabled={loading || isLocked}
                        >
                            {isLocked ? 'Temporarily Locked' : (
                                loading ? (
                                    <div className="button-loader">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                ) : 'Access Preview'
                            )}
                        </button>
                        
                        {error && (
                            <div className="error-message">
                                {error}
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </div>
    );
};

export default PasswordProtection; 